var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLighthouse = function SvgLighthouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 246,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lighthouse_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF7C7C",
    d: "M16.21 56h40.305l13.21 188H3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m3.536 243.5 13.14-187H56.05l13.14 187z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#lighthouse_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.515 56H16.211l-3.508 49.927h47.32zM9.582 150.344h53.563l3.29 46.828H6.291z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M13.239 105.427 16.677 56.5h39.372l3.438 48.927zm-6.412 91.245 3.22-45.828H62.68l3.22 45.828z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#484E61",
    stroke: "#000",
    d: "m.694 245.5 1.666-5h68.28l1.666 5zM32.5 12.5a4 4 0 0 1 8 0v3h-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M36.5 8.5v-8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD4E4E",
    stroke: "#000",
    d: "M30.5 18.5a6 6 0 0 1 12 0v5h-12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD4E4E",
    stroke: "#000",
    d: "M23.5 31.5c0-7.18 5.82-13 13-13s13 5.82 13 13v24h-26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#484E61",
    stroke: "#000",
    d: "M23.5 31.5c0-7.18 5.82-13 13-13s13 5.82 13 13v5h-26zM22.5 78a5.5 5.5 0 1 1 11 0v12.5h-11zM43.5 125a5.5 5.5 0 1 1 11 0v12.5h-11zM16.5 175a5.5 5.5 0 1 1 11 0v12.5h-11zM44.5 228a5.5 5.5 0 1 1 11 0v12.5h-11z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 35.5,
    r: 6,
    fill: "#D9D9D9",
    stroke: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M14.484 54V44m44.032 0v10M13 47.75h47M48.126 44v10M36.747 44v10M25.368 44v10"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#484E61",
    stroke: "#000",
    d: "M13.5 53.5h46v5h-46z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lighthouse_svg__a",
    width: 66.725,
    height: 188,
    x: 3,
    y: 56,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_32299_10169"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lighthouse_svg__b",
    width: 60.145,
    height: 141.172,
    x: 6.291,
    y: 56,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_32299_10169"
  })))));
};
export default SvgLighthouse;